import React, { Component } from 'react';
import { like_follow, getLike, getSchoolCategoryIdBySlug, getNameBySlug } from '../../API/FetchCall';
// import Rating from 'react-star-rating-component';

class FollowOnly extends React.Component {
    constructor(props) {
        super(props);
        let data_auth = (localStorage.getItem("myData"));
        let auth_data = JSON.parse(data_auth);
        let id = '';
        if (auth_data) {
            id = auth_data.user_id;
        }
        this.state = {
            user_likes: 2,
            user_follow: 2,
            user_id: id,
            auth: false,
            is_follow_count: 0,
            is_like_count: 0,
        };
    }

    componentDidMount() {

        let data_auth = (localStorage.getItem("myData"));
        console.log('**', this.state.user_id)
        if (data_auth) {
            let auth_data = JSON.parse(data_auth)
            // console.log('**', auth_data.user_id)
            this.setState({
                logged_name: auth_data.first_name + ' ' + auth_data.last_name,
                authe: true,
                user_id: auth_data.user_id,
            });
        }
        this.GetDeta(this.state.user_id);


    }

    GetDeta(user_id) {

        let SlugName = JSON.stringify({
            category_slug: this.props.paramId.category_name
        });
        getSchoolCategoryIdBySlug(SlugName).then((response) => {
            if (response.status == 1) {
                let slugData = JSON.stringify({
                    slug: this.props.paramId.ref_name,
                    categoryname: this.props.paramId.whichtable
                });
                console.log("table", this.props.paramId.whichtable);
                console.log(slugData);
                getNameBySlug(slugData, this.props.paramId.whichtable).then((response2) => {
                    if (response2.status == 1) {

                        let reviewData = JSON.stringify({
                            user_id: user_id,
                            category: response.subcategory_id,
                            main_category: this.props.paramId.category_id,
                            ref_id: response2.id
                        });
                        console.log('**', reviewData)
                        getLike(reviewData).then((response) => {
                            let toastr = '';
                            console.log('responseresponse', response)
                            if (response.status == 1) {
                                console.log(response)
                                this.setState({
                                    is_like_count: response.data.likes,
                                    is_follow_count: response.data.follow,
                                    user_likes: response.data.user_likes,
                                    user_follow: response.data.user_follow
                                })
                            }
                        });
                    }
                });

            }
        });
    }


    Follow = (is_follows) => {

        let SlugName = JSON.stringify({
            category_slug: this.props.paramId.category_name
        });
        getSchoolCategoryIdBySlug(SlugName).then((response) => {
            if (response.status == 1) {
                let slugData = JSON.stringify({
                    slug: this.props.paramId.ref_name,
                    categoryname: this.props.paramId.whichtable
                });

                getNameBySlug(slugData, this.props.paramId.whichtable).then((response2) => {
                    if (response2.status == 1) {

                        let reviewData = JSON.stringify({
                            user_id: this.state.user_id,
                            main_category: this.props.paramId.category_id,
                            category: response.subcategory_id,
                            vendor_id: this.props.paramId.vendor_id,
                            ref_id: response2.id,
                            is_follow: is_follows
                        });

                        like_follow(reviewData).then((response) => {
                            let toastr = '';
                            let msg = is_follows ? 'Successfully started following' : 'Successfully unfollowing';
                            if (response.status == 1) {
                                this.GetDeta(this.state.user_id);
                                if(is_follows){
                                    toastr = window.toastr.success; //warning
                                    toastr('', msg, {
                                        positionClass: "toast-bottom-center",
                                        containerId: "toast-bottom-center"
                                    });
                                }
                                else{

                                    toastr = window.toastr.error; //warning
                                    toastr('', msg, {
                                        positionClass: "toast-bottom-center",
                                        containerId: "toast-bottom-center"
                                    });
                                }

                                

                            } else {
                            }
                        });

                    }
                });

            }
        });
    }

    isFollow(is_fol) {
        this.Follow(is_fol);
    }


    render() {

        return (

            <React.Fragment>

                {(this.state.user_follow === 2) ?
                    <div className="followerscount" title="Hit if you are happy with this Institution or the information provided by this Institution @ this page." onClick={() => this.isFollow(true)}> Followers: <span>{this.state.is_follow_count}</span></div>
                    :
                    <div className="followerscount" title="Hit if you are happy with this Institution or the information provided by this Institution @ this page." onClick={() => this.isFollow(false)}> Followers: <span>{this.state.is_follow_count}</span></div>
                }

            </React.Fragment >


        )


    }


}
export { FollowOnly };
